import { render } from "./NewTubeFormComponent.vue?vue&type=template&id=1e4e9cf1"
import script from "./NewTubeFormComponent.vue?vue&type=script&lang=js"
export * from "./NewTubeFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__